export default __webpack_public_path__ + "static/media/roadmap_2.482c8cbc.png";